export default "__VITE_ASSET__d51f9b22__"